import { GLOBAL_NAME } from '../constants/Globals';
import { SET_SUBJECT_FOR_THIRD_PARTIES } from '../constants/EventListeners';
export function triggerHostMessageSetSubjectForThirdParties(data) {
  if (window[GLOBAL_NAME].triggerEvent) {
    window.hsCalling.triggerEvent({
      event: SET_SUBJECT_FOR_THIRD_PARTIES,
      data
    });
  }
}